import { useEffect, useSyncExternalStore } from 'react';
import {
  isGoogleMapsLoaded,
  isGoogleMapsLoadFailed,
  requestGoogleMapsLoad,
  subscribeToGoogleMapsLoader,
} from './googleMapsLoaderStore';

/**
 * Requests Google Maps through the app's shared @vis.gl loader host.
 * The persistent map and imperative consumers therefore use the same
 * provider-owned initialization sequence.
 *
 * Pass `enabled: false` to defer the (multi-hundred-KB) load until the
 * consumer actually needs Maps — an already-loaded runtime still reports true.
 */
export function useGoogleMapsLoaded(enabled = true): boolean {
  const loaded = useSyncExternalStore(subscribeToGoogleMapsLoader, isGoogleMapsLoaded, () => false);

  useEffect(() => {
    if (enabled) requestGoogleMapsLoad();
  }, [enabled]);

  return loaded;
}

/** True once the shared loader host reported a Maps script/provider failure. */
export function useGoogleMapsLoadFailed(): boolean {
  return useSyncExternalStore(subscribeToGoogleMapsLoader, isGoogleMapsLoadFailed, () => false);
}
